import styled from "styled-components";
import media from "constants/media";

export const StoresStyled = styled.div`
    margin-bottom: 20px;
    padding: 20px;

    color: var(--color-darkNight);
    text-align: center;

    background: var(--color-white);
    box-shadow: 10px 10px 24px 0 rgba(0, 23, 75, 0.05);

    ${media.mdUp`

        width: 100%;
        padding: 40px;
    `}
`;

export const Title = styled.h2`
    font-size: 18px;
    font-family: var(--font-DINProCondensed);
    line-height: 25px;
    letter-spacing: 1.5px;
    text-align: center;
    text-transform: uppercase;

    ${media.mdUp`
        margin-bottom: 15px;
        font-size: 20px;
        line-height: 30px;
    `}
`;
